import React, {useState} from 'react';
import {offertsService} from '../../service/offertsService';
import {entities} from '../../utilis/entitiesNames';
import {useHistory} from 'react-router-dom';
import BFormWrapper from '../../forms/BFormWrapper';
import BSpinner from '../../components/spinners/BSpinner';

export default function OffersPage() {
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState([]);
  const [success, setSuccess] = useState(false);
  const [addAnother, setAddAnother] = useState(false);
  const [sendBrokers, setSendBrokers] = useState(false);
  const [sendUsers, setSendUsers] = useState(true);
  const history = useHistory();

  const tryAdd = (formData) => {
    setIsLoading(true);
    setErrors([]);
    setSuccess(false);

    formData.sholudBeSendToCustomers = sendUsers;

    offertsService
      .add(formData)
      .then(() => {
        setSuccess(true);

        if (!addAnother) {
          history.push(`/${entities.OFFERTS}`);
        }
      })
      .catch((err) => {
        setSuccess(false);

        if (err.response) {
          setErrors(err.response.data);
        }
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <>
      {isLoading && <BSpinner />}
      {!isLoading && (
        <div className="m-6 bg-white border-gray-400 rounded shadow-md relative">
          <BFormWrapper
            name={entities.OFFERTS}
            onSubmit={tryAdd}
            responseErrors={errors}
            success={success}
          />
          <div className="absolute flex items-center text-l mt-3 pb-6">
            <label className="flex">
              <input
                value={addAnother}
                onChange={() => setAddAnother((prev) => !prev)}
                type="checkbox"
                className="form-checkbox h-5 w-5 text-gray-600"
              />
              <span className="ml-2 text-gray-700">Neue hinzufügen</span>
            </label>
          </div>
          <div className="absolute flex items-center text-l right-0 mt-3 pb-6">
            <label className="flex">
              <input
                className="ml-2 mt-1"
                type="radio"
                name="Users"
                value="USERS"
                checked={sendUsers}
                onChange={(value) => 
                  {
                    setSendUsers(value);
                    setSendBrokers(false);
                  }}
              />
              <span className="ml-2 text-gray-700">Nutzer</span>
            </label>
            <label className="flex">
              <input
                className="ml-5 mt-1"
                type="radio"
                name="Brokers"
                value="BROKERS"
                checked={sendBrokers}
                onChange={(value) => 
                  {
                    setSendBrokers(value);
                    setSendUsers(false);
                  }}
              />
              <span className="ml-2 text-gray-700">Makler</span>
            </label>
          </div>
        </div>
      )}
    </>
  );
}
